import "@/index.css";

export const Branding = (): JSX.Element => (
  <div className="inline-flex items-center font-branding text-2xl font-semibold text-red-secondary">
    <a
      href="https://github.com/hackworthltd/primer"
      target="_blank"
      rel="noopener noreferrer"
    >
      :P
    </a>
  </div>
);

export default Branding;
